var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoHistorias(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 23L25 20.5L28 18.5L34.5 17.5L41 21L44 22L44.5 24V26L43.5 27.5C43.3333 27.1667 42.9 27.4 42.5 31C42.1 34.6 40 36.5 39 37V39.5L43 40.5L48.5 42L53.5 44L54 47.5L53 53L38 60H25H21.5L16 57L14 53L13.5 49L14 45L16 42.5L28.5 39.5L29 37.5L28.5 37L26.5 35L25 31L24.5 27.5L23 26.5L23.5 23Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6973 22.554V30.2149C24.8937 32.9649 27.408 38.4651 33.5368 38.4651C41.1977 38.4651 42.9656 32.5721 42.9656 29.0363C42.9656 26.1686 42.9656 25.5005 42.9656 22.554M28.8224 37.2865V40.233C30.5903 41.4116 35.069 43.0616 38.8405 40.233V37.2865",
    stroke: "#444444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9648 29.6255L42.9648 21.9646C42.7684 19.2145 40.2541 13.7144 34.1253 13.7144C26.4644 13.7144 24.6965 19.6074 24.6965 23.1432C24.6965 26.0108 24.6965 26.679 24.6965 29.6255",
    stroke: "#444444"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8218 39.6436L17.0358 42.0008C15.8572 42.1972 13.5 43.4151 13.5 46.7152C13.5 47.5512 13.5 48.6318 13.5 49.8305C13.5 55.5953 18.1733 60.2691 23.938 60.2691H43.7237C49.4885 60.2691 54.1618 55.5958 54.1618 49.831V47.579C54.1618 47.0041 54.2413 46.4253 54.1693 45.8549C54.0054 44.558 53.0477 42.7535 50.0367 42.0008C46.2651 41.0579 40.8043 40.0364 38.8399 39.6436",
    stroke: "#444444"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6966 21.9646C24.1073 22.161 22.9287 23.0253 22.9287 24.9111C22.9287 26.7969 24.1073 27.6612 24.6966 27.8576",
    stroke: "#444444"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9645 27.8577C43.5538 27.6612 44.7324 26.7969 44.7324 24.9112C44.7324 23.0254 43.5538 22.1611 42.9645 21.9647",
    stroke: "#444444"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1767 19.018C31.3481 21.8466 25.5336 22.9466 22.98 23.1431C22.5871 18.4287 24.2765 9 34.1767 9C44.077 9 45.3734 18.4287 44.7841 23.1431C37.1232 23.1431 35.3553 20.1967 34.1767 19.018Z",
    fill: "#0099CC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1008 47.2076C46.6801 42.0642 44.6318 30.1242 55.8042 23.5112C58.0387 27.9199 60.8318 38.3904 49.1008 47.2076Z",
    fill: "#0099CC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1904 60.4335L49.1008 47.2076M49.1008 47.2076C46.6801 42.0642 44.6318 30.1242 55.8042 23.5112C58.0387 27.9199 60.8318 38.3904 49.1008 47.2076Z",
    stroke: "#0099CC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8453 35.2183L49.6934 45.5745",
    stroke: "white",
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2871 50.5277C40.2871 49.8091 40.8696 49.2266 41.5882 49.2266H55.9969C56.7155 49.2266 57.298 49.8091 57.298 50.5277V53.6298H40.2871V50.5277Z",
    fill: "white",
    stroke: "#444444"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5859 57.732C37.5859 55.5213 39.378 53.7292 41.5887 53.7292H55.9974C58.208 53.7292 60.0001 55.5213 60.0001 57.732V58.6325C60.0001 60.3458 58.6112 61.7347 56.8979 61.7347H40.6881C38.9748 61.7347 37.5859 60.3458 37.5859 58.6325V57.732Z",
    fill: "white",
    stroke: "#444444"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 31L54.6465 31.6162",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHistorias);
export default __webpack_public_path__ + "static/media/ico_historias.f8c603aaf2b91956466d7eb96ad53151.svg";
export { ForwardRef as ReactComponent };